<template>
	<div class="card main">
		<nav>
			<div class="nav-wrapper indigo darken-3">
				<a href="#" class="brand-logo center">Настройки</a>
			</div>
		</nav>
		<div class="card-content">
			<form class="row" @submit.prevent="submit">
				<div class="row">
					<div class="col s12">
						<label>
							<input type="checkbox" v-model="is_root"/>
							<span>Права ROOT</span>
						</label>
					</div>
					<div class="col s12">
						<label>
							<input type="checkbox" v-model="read_only"/>
							<span>Полько для чтения</span>
						</label>
					</div>
					<div class="col s12">
						<label>
							<input type="checkbox" v-model="enabled"/>
							<span>Включить</span>
						</label>
					</div>
				</div>
				<div class="row">
					<div class="input-field col s12">
						<textarea id="textarea1"
						          class="materialize-textarea" v-model="note"></textarea>
						<label for="textarea1">Короткое описание</label>
					</div>
				</div>
				<button @click.prevent="next"
				        class="waves-effect waves-light btn right indigo darken-3">создать
				</button>
			</form>
		</div>
	</div>
</template>
<script>
	export default {
		name:    "FormSettings",
		data() {
			return {
				is_root:   false,
				enabled:   true,
				read_only: true,
				note:      ""
			};
		},
		mounted() {
			document.querySelector('textarea').focus()
		},
		methods: {
			next() {
				this.$emit("createAdmin", {
					is_root:   this.is_root,
					enabled:   this.enabled,
					read_only: this.read_only,
					note:      this.note
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "../../assets/scss/admin";
</style>
